import styled from '@emotion/styled';
import { fontSizes } from 'app/typography';

export default styled.input`
  flex: 1;
  font-size: ${fontSizes.text};
  letter-spacing: -0.00125em;
  color: var(--color-font-primary);
  background-color: transparent; // No default grey when disabled
  outline: none;
  border: none;
  padding: 0;
  &::placeholder {
    color: var(--color-font-placeholder);
  }
`;
